import useFetch from '@hooks/useFetch';

const getKey = (goalUID, type = 1) =>
  goalUID
    ? `v1/catalogues/browse/all/?goal_uid=${goalUID}&offset=0&limit=100&type=${type}`
    : null;

const useCatalogue = (goalUID, type) => {
  const key = getKey(goalUID, type);
  const { data, ...rest } = useFetch(key, {}, { revalidateOnMount: true });

  return {
    catalogueData: data?.results || [],
    rest
  };
};

export const useBookCatalogue = (goalUID) => {
  const { catalogueData: bookCatalogues, ...rest } = useCatalogue(goalUID, 1);

  return {
    key: getKey(goalUID, 1),
    bookCatalogues,
    ...rest
  };
};

export const usePYQCatalogue = (goalUID) => {
  const { catalogueData: pyqCatalogues, ...rest } = useCatalogue(goalUID, 2);

  return {
    key: getKey(goalUID, 2),
    pyqCatalogues,
    ...rest
  };
};
